<template>
<div class="flex justify-center">
  <!-- Logo for dark mode -->
  <img
    src="/assets/logo-dark.png"
    alt="Logo"
    class="mb-4 hidden w-3/5 min-w-60 dark:block"
  >
  <!-- Logo for light mode -->
  <img
    src="/assets/logo.png"
    alt="Logo"
    class="mb-4 block w-3/5 min-w-60 dark:hidden"
  >
</div>
</template>